import styled from 'styled-components';
import { breakpoints } from '../../../styles/theme';
import StockSliceTemplate from './StockSliceTemplate';
import { rem } from 'polished';
import { trimCarouselBreakpoints } from '../../../styles/trimCarouselBreakpoints';

export const StockSliceStyled = styled(StockSliceTemplate)`
    width: 100%;

    .spinner {
        margin: 2em auto;
    }

    .carouselArrows-wrapper__btnsSection {
        display: none;

        @media (max-width: ${trimCarouselBreakpoints.lg}px) {
            display: flex;
        }
    }

    .header {
        padding: ${rem(10)} ${rem(20)};
        background: ${({ theme }) => theme.colors.white};
        border-top: 1px solid ${({ theme }) => theme.colors.black};

        @media (max-width: ${breakpoints.md}px) {
            display: flex;
            flex-direction: column;
        }

        &-location-input {
            @media (min-width: ${breakpoints.md}px) {
                display: flex;
            }
        }

        &-location-button {
            font-size: ${({ theme }) => theme.fontSizes.textBase};
            background: ${({ theme }) => theme.colors.white};
            border: none;
            color: ${({ theme }) => theme.colors.primary};
            cursor: pointer;
            padding: 0;

            &:hover,
            &:focus-visible {
                color: ${({ theme }) => theme.colors.primary};
                border-color: ${({ theme }) => theme.colors.primary};
            }

            @media (min-width: ${breakpoints.md}px) {
                color: ${({ theme }) => theme.colors.black};
                text-transform: uppercase;
                border: 1px solid ${({ theme }) => theme.colors.black};
                padding: ${rem(10)} ${rem(20)};
                font-weight: ${({ theme }) => theme.fontWeights.textBold};
                font-size: ${({ theme }) => theme.fontSizes.textTiny};

                .icon-wrapper {
                    display: none;
                }
            }

            svg {
                height: ${rem(9)};
                width: ${rem(12)};

                path {
                    fill: ${({ theme }) => theme.colors.primary};
                }
            }
        }

        &-title {
            &-main {
                font-weight: ${({ theme }) => theme.fontWeights.textBold};
                font-size: ${({ theme }) => theme.fontSizes.h4};
                line-height: ${({ theme }) => theme.lineHeights.textSupBig};
            }
            &-description {
                font-size: ${({ theme }) => theme.fontSizes.textMedium};
                line-height: ${({ theme }) => theme.lineHeights.h5};

                @media (min-width: ${breakpoints.md}px) {
                    padding-left: ${rem(15)};
                }
            }
        }
    }

    .vehicles {
        padding: ${rem(20)} ${rem(100)};
        background: ${({ theme }) => theme.colors.white};
        @media (max-width: ${trimCarouselBreakpoints.lg}px) {
            padding: ${rem('15px')};
        }
        @media (max-width: ${breakpoints.md}px) {
            padding: unset;
        }
    }

    .vehicles > div {
        margin: 0 auto;
    }

    .header-location {
        @media (min-width: ${breakpoints.md}px) {
            display: flex;
            justify-content: space-between;
        }
        .geolocation-title {
            display: none;
        }
    }
`;
